import { render, staticRenderFns } from "./loansummary_details.vue?vue&type=template&id=4e8f5a0e&scoped=true"
import script from "./loansummary_details.vue?vue&type=script&lang=js"
export * from "./loansummary_details.vue?vue&type=script&lang=js"
import style0 from "./loansummary_details.vue?vue&type=style&index=0&id=4e8f5a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f5a0e",
  null
  
)

export default component.exports